import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=a1ac6a3c&scoped=true&"
import script from "./rule.vue?vue&type=script&lang=js&"
export * from "./rule.vue?vue&type=script&lang=js&"
import style0 from "./rule.vue?vue&type=style&index=0&id=a1ac6a3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ac6a3c",
  null
  
)

export default component.exports